import { render } from "./HeroiconsSolidCloudDownload.vue?vue&type=template&id=aa9a2336"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCloudDownload.vue"]])

export default __exports__